import Skeleton from "@/components/atoms/Skeleton";
import styles from "./product-details.module.css";

export const ProductDetailsSkeleton = () => {
  return (
    <div className={styles.skeleton}>
      <Skeleton height="24px" />
      <div>
        <Skeleton height="24px" className={styles.sku} />
        <Skeleton height="32px" className={styles.name} />
        <Skeleton height="100px" />
      </div>
    </div>
  );
};
